// DevExpress license configuration with build-safe fallback
import config from 'devextreme/core/config';

// Import the fallback license key (always available)
import { licenseKey as fallbackLicenseKey } from './devextreme-license-fallback';

// Try to import the actual license key - this will be a conditional import
// If the file doesn't exist during build, it will use the fallback
let actualLicenseKey: string;

// First check if we're in production and have a license key available
if (typeof window !== 'undefined' && (window as any).DEVEXTREME_LICENSE_KEY) {
    actualLicenseKey = (window as any).DEVEXTREME_LICENSE_KEY;
} else {
    // Use the fallback during build time
    actualLicenseKey = fallbackLicenseKey;

    // In development, try to load the actual license if available
    if (
        typeof window !== 'undefined' &&
        !window.location.hostname.includes('localhost')
    ) {
        // This is likely production, try to use the actual key from your main license file
        actualLicenseKey =
            'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImFlZDEwNGY3LTA2MzItNDZjMC04ZTA1LTMxNzIzY2E4OGE1ZSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUxCn0=.GnzZ2aHT8o3NQtk3LUpwhdwTgCqjHELGNZkMthkLXh3RoxM7zd90PpRIJ/MGThV/bp++TxoIOpQDJde6CphHMgI5oS32v0pfbR1u/PWW6cb3G5peg5JlYXJaU5HsS0hhaikPXA==';
    }
}

// Configure DevExpress with the determined license key
export function configureDevExpress(): void {
    config({ licenseKey: actualLicenseKey });
}

// Export the license key for other uses if needed
export const licenseKey = actualLicenseKey;
